import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

export default function PageHeader({ chapter, eyebrow, title, blurb }) {
  return (
    <section className="relative pt-40 md:pt-52 pb-16 md:pb-24 bg-[#FAFAF5] overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-60 -z-10" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#DC2626] flex items-center gap-3 mb-8">
          <span className="w-8 h-px bg-[#DC2626]" /> {chapter} — {eyebrow}
        </div>
        <div className="grid md:grid-cols-12 gap-10">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: EASE }}
            className="md:col-span-8 font-display uppercase text-[#0A0A0A] text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight"
          >
            {title}
          </motion.h1>
          {blurb && (
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
              className="md:col-span-4 md:pt-3 text-[#0A0A0A]/70 leading-relaxed self-end"
            >
              {blurb}
            </motion.p>
          )}
        </div>
      </div>
    </section>
  );
}
